module.exports = __webpack_public_path__ + "img/组 21.be417a11.png";